import { RefObject, useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { IGroupActionButtonRefActions } from '@molecules/GroupActionButton/GroupActionButton';
import { DataGridRow } from './dataGridSchema';

export interface IDataGridActions {
    openRowLink: (href: string) => void;
    /** Растёт при изменении данных действием — грид перезапрашивает строки. */
    refreshToken: number;
    refresh: () => void;
    groupActionsRef: RefObject<IGroupActionButtonRefActions | null>;
    onSelectionChange: (keys: string[], rows: DataGridRow[]) => void;
    /** Запрос выбора строк для грида (`selectionRequest`) */
    selectionRequest?: { keys: string[]; seq: number };
    /** Выбрать строки грида — «Выделить неудачные» групповой операции */
    selectKeys: (keys: string[]) => void;
}

/** Обвязка грида действиями: переход по строке, обновление данных и выборка,
 *  которую видит кнопка групповых действий. */
export function useDataGridActions(): IDataGridActions {
    const navigate = useNavigate();
    const openRowLink = useCallback(
        (href: string) => {
            void navigate(href);
        },
        [navigate],
    );
    const [refreshToken, setRefreshToken] = useState(0);
    const refresh = useCallback(() => setRefreshToken((token) => token + 1), []);
    const groupActionsRef = useRef<IGroupActionButtonRefActions>(null);

    const onSelectionChange = useCallback((keys: string[], rows: DataGridRow[]) => {
        groupActionsRef.current?.setObjData(keys.join(','), rows);
    }, []);

    const [selectionRequest, setSelectionRequest] = useState<{ keys: string[]; seq: number }>();
    const selectKeys = useCallback(
        (keys: string[]) => setSelectionRequest((previous) => ({ keys, seq: (previous?.seq ?? 0) + 1 })),
        [],
    );

    return { openRowLink, refreshToken, refresh, groupActionsRef, onSelectionChange, selectionRequest, selectKeys };
}
